import { SeatMapsInt, SeatmapCollectionInt } from "@app/interfaces";

export class SeatMapsMapper {

  private static seatMaps: SeatMapsInt[];

  constructor() { }

  static getSeatMaps(res: SeatmapCollectionInt): SeatMapsInt[] {
    this.seatMaps = [];
    let seatRes = [];

    if (res && res.seatMap && res.seatMap.length > 0) {
      this.seatMaps = res?.seatMap;

      if (!this.seatMaps || !this.seatMaps[0]?.seatSummary || !this.seatMaps[0]?.sections) {
        return [];
      }

      seatRes = this.parseJson(this.seatMaps);
    }

    return seatRes;
  }

  private static parseJson(seatJson) {
    let seatMaps = [];
    let legs = seatJson;
    let seatC:any
    for (let index = 0; index < legs.length; index++) {
      this.parseLeg(legs[index], index, seatMaps);
      seatC = seatMaps
    }
    return seatC;
  }

  private static parseLeg(leg, legIndex, seatMaps) {
    let seatMap = {};
    let sectionInfo = [];
    let sections = leg.sections;
    const aircraftType = leg.segment?.aircraftType;
    seatMaps[legIndex] = {
      segment: leg.segment,
      seatMap: seatMap,
      sectionInfo: this.parseSectionInfo(sections, aircraftType),
      seatSummary: leg.seatSummary,
      seatSelectionFee: leg.seatSelectionFee,
      status: leg.status,
      seatDistributionCollection:leg.seatDistributionCollection
    };
    for (let index = 0; index < sections.length; index++) {
      this.parseSection(sections[index], seatMap, sectionInfo,index, seatMaps[legIndex]);
    }
  }

  private static parseSection(section, seatMap, sectionInfo,index, seatMapInfo) {
    let sectionCode = this.convertSectionCode(section);
     sectionInfo[index] = section;
    let rows = section.rows;

    for (let index = 0; index < rows.length; index++) {
      let isFirstRowOfSection = (index == 0);
      this.parseRow(rows[index], sectionCode, seatMap, isFirstRowOfSection, seatMapInfo);
    }
  }

  private static parseRow(row, sectionCode, seatMap, isFirstRowOfSection, seatMapInfo) {
    let seats = row.seats;

    for (let index = 0; index < seats.length; index++) {
      this.parseSeat(seats[index], sectionCode, seatMap, isFirstRowOfSection,seatMapInfo);
    }
  }

  private static parseSectionInfo(sections, _aircraftType?: string) {
    if (!sections || sections.length === 0) {
      return [];
    }

    return this.organizeByRowOrder(sections);
  }

  private static organizeByRowOrder(sections) {
    const allRows = [];

    for (const section of sections) {
      if (section.rows && section.rows.length > 0) {
        for (const row of section.rows) {
          if (row.seats && row.seats.length > 0) {
            allRows.push(row);
          }
        }
      }
    }

    allRows.sort((a, b) => parseInt(a.code, 10) - parseInt(b.code, 10));

    const organizedSections = [];
    let currentSection = null;

    for (const row of allRows) {
      const typeCounts = {};
      for (const seat of row.seats) {
        typeCounts[seat.seatType] = (typeCounts[seat.seatType] || 0) + 1;
      }
      const seatType = Object.keys(typeCounts).reduce((a, b) =>
        typeCounts[a] >= typeCounts[b] ? a : b
      );

      if (!currentSection || currentSection.code !== seatType) {
        currentSection = { code: seatType, rows: [] };
        organizedSections.push(currentSection);
      }

      currentSection.rows.push(row);
    }

    return organizedSections;
  }

  private static parseSeat(seat, sectionCode, seatMap, setSectionInfo , seatMapInfo) {
    let seatId = seat.code;
    seatMap[seatId] = seat;
    seat.seatId = seatId;
    seat.section = sectionCode;
    seat.assigned = false;
    seat.currentAssigned = false;

    if (seat.currency) {
      seat.cost = seat.currency.base;
    }
    else if ( seat.choice.subjectToSeatSelectionFee) {
      seat.cost = seatMapInfo.seatSelectionFee.total;
    } else {
      seat.cost = 0;
    }

    if (setSectionInfo)
      seat.sectionInfo = sectionCode;
    else
      seat.sectionInfo = null;
  }

  private static convertSectionCode(section) {
    switch (section.code) {
      case "FIRST_CLASS":
        section.name = 'Premiere Class';
        section.class = 'firstClass';
        return 1;
      case "AM_PLUS":
        section.name = 'AM Plus';
        section.class = 'amPlus';
        return 2;
      case "PREFERRED":
        section.name = 'Preferred Seating';
        section.class = 'amPreferred';
        return 3;
      case "EXIT_ROW":
        section.name = 'Emergency exit';
        section.class = 'amPreferred';
        return 3;
      case "COACH":
        section.name = 'Coach';
        section.class = 'coach';
        return 4;
      default:
        return -1;
    }
  }
}
